import { useQuery } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useGetUsersByProject = (currentPage, pageSize, searchValue, status, projectId) => {
  const data = useQuery(
    ["usersByProject", currentPage, pageSize, searchValue, status, projectId],
    () =>
      axiosClient.get(
        `/User/GetUserListByProject?currentPage=${currentPage}&pageSize=${pageSize}&searchValue=${searchValue}&status=${status}&projectId=${projectId}`
      )
  );

  return data;
};
export default useGetUsersByProject;
